import React, { useCallback } from 'react';
import JsonPreview from '../JsonPreview.jsx';
import useToggle from '../hooks/useToggle.jsx';

export default function HashPropertyActions(props) {
  const modalToggle = useToggle(false);
  const handleEditClick = useCallback(
    () => Turbolinks.visit(props.editLink),
    [],
  );

  return (
    <div>
      <If condition={!props.readonly}>
        <a
          className='ui left attached primary button'
          onClick={handleEditClick}
        >
          <i className='icon edit'></i>
          Edit
        </a>
      </If>
      <a
        className={`ui button border-radius ${props.readonly ? '' : 'right attached'}`}
        onClick={modalToggle.toggle}
      >
        <i className='file outline icon'></i>
        Preview
      </a>

      <JsonPreview
        hosts={props.hosts}
        link={props.valueLink}
        name={props.templateName}
        open={modalToggle.value}
        renderedEntity={'hash'}
        title={props.title}
        onClose={modalToggle.toggle}
      />
    </div>
  );
}
